import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatTableCrudEditComponent } from "../../../shared/components/mat-table-crud/mat-table-crud-edit.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { LoggerService } from "../../../shared/services/logger.service";
import { Podcast } from "../../calendars/calendars.models";
import { AdministrationService } from '../administration.service';
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";

import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";


@Component({
    templateUrl: './podcast-edit.component.html',
    selector: 'podcast-edit-form',
    styleUrls: ['../../../shared/components/mat-table-crud/mat-table-crud.component.scss', './podcasts.component.scss'],
    providers: [MatTableCrudService],
    standalone: true,
    imports: [CdkDrag, FormsModule, ReactiveFormsModule, CdkDragHandle, MatDialogTitle, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDialogActions, MatButtonModule]
})
export class PodcastEditComponent extends MatTableCrudEditComponent<PodcastEditComponent, Podcast>
{
  constructor(public fb: UntypedFormBuilder, public dialogRef: MatDialogRef<PodcastEditComponent>, @Inject(MAT_DIALOG_DATA) public data: Podcast, public administrationService: AdministrationService, public authorisationService: AuthorisationService, public loggerService: LoggerService)
  {
    super(dialogRef, data);

    this.form = this.fb.group({
      Id: [this.data.Id],
      Name: [this.data.Name, Validators.required],
      Disabled: [this.data.Disabled],
      SortOrder: [this.data.SortOrder, Validators.compose([Validators.required, Validators.pattern('^\\d+$')])]
    });
  }

  ngOnInit()
  {
    super.ngOnInit();
  }

  onSave(): void
  {
    const podcast: any = this.form.value;

    if (podcast)
    {
      if (this.isNew)
      {
        podcast.Id = 0;

        if (podcast.Disabled == null)
        {
          podcast.Disabled = false;
        }
      }

      super.onSave(podcast);
    }
  }

  get dialogHeaderText(): string
  {
    let headerText = "Edit Podcast";

    if (this.isNew)
    {
      headerText = "New Podcast";
    }
    else
    {
      if (this.showEditItemNameInHeaderText)
      {
        headerText = `${headerText} - ${this.data.Name}`;
      }
    }

    return headerText;
  }

  ngOnDestroy()
  {
    super.ngOnDestroy();
  }
}
